import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { useMutation, useQueryClient } from 'react-query';
import { successToast } from 'lib/components/toasts/success';

export const archiveVideos = async (
  videoIds: number[],
  isArchived: number | boolean
): Promise<{ success: boolean }> => {
  const response = await EXPRESS_API.patch(`/videos/archive`, {
    videoIds,
    isArchived,
  });
  return response.data;
};

export const useUpdateVideoArchiveStatusMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (data: { videoIds: number[]; isArchived: boolean }) =>
      archiveVideos(data.videoIds, data.isArchived),
    {
      onError: () => {
        errorToast({
          title:
            'Failed to update video archive status. Please try again later.',
        });
      },
      onSuccess: async (_data, variables) => {
        successToast({
          title: `Video ${!!variables.isArchived ? 'archived' : 'unarchived'} successfully`,
        });
        queryClient.invalidateQueries('cds-videos');
      },
    }
  );
};
